import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import AddQuestionsTable from './AddQuestions';
const AddQuestions = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle='Add Questions' parent='Add Questions'  />
      <Container fluid={true}>
        <Row>
          <AddQuestionsTable />
        </Row>
      </Container>
    </Fragment>
  );
};

export default AddQuestions;
